import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import {
  ButtonType,
  CustomButton,
  CustomTextField,
} from "@BehpardazBarin/frontend_components";
import { customInputProps } from "../constants/Style";
import InfoIcon from "@mui/icons-material/Info";
import { BackButton } from "../components/Common/BackButton";
import { snackActions } from "../utils/SnackbarUtils";
import { useMutation } from "@tanstack/react-query";
import { forgotpassword } from "../services/Forgotpassword";
import { useNavigate } from "react-router";

const ForgotPassword: React.FC = () => {
  const theme = useTheme();
  const [userCode, setUserCode] = React.useState<string | number>("");
  const [phoneNumber, setPhoneNumber] = React.useState<string | number>("");

  const handleChangeUser = (val: string | number) => {
    setUserCode(val);
  };

  const handleChangePhoneNumber = (val: string | number) => {
    setPhoneNumber(val);
  };
  const forgotpassMutation = useMutation({
    mutationFn: forgotpassword,
  });

  const navigate = useNavigate();
  const handleLogin = () => {
    if (!userCode || !phoneNumber) {
      snackActions.error("لطفا موارد الزامی را کامل بفرمایید");
      return;
    }
    const params = {
      username: userCode,
      mobile: phoneNumber,
    };

    forgotpassMutation.mutate(params, {
      onSuccess: (response) => {
        navigate("/login");
      },
    });
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
      }}
    >
      <BackButton />
      <Box
        sx={{
          alignSelf: "center",
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          textAlign="center"
          sx={{ fontFamily: "IRANSansXBold" }}
        >
          فراموشی رمز عبور
        </Typography>
        <Typography
          variant="body2"
          mb={6}
          textAlign="center"
          sx={{
            color: "#1212128F",
            fontFamily: "IRANSansX",
            // width: "70%", mx: "auto"  ADDED AFTER ADDING AN IsMobile  THIS IS FOR MOBILE
          }}
        >
          لطفا اطلاعات زیر را تکمیل و روی دکمه ثبت کلیک کنید تا رمز عبور جدید
          برای شما پیامک شود.
        </Typography>

        <CustomTextField
          label="کد ملی"
          value={userCode}
          placeholder={"کد ملی خود را وارد کنید..."}
          onChange={handleChangeUser}
          {...customInputProps(theme)}
          autoFocus={true}
        />

        <CustomTextField
          label={"شماره موبایل"}
          value={phoneNumber}
          placeholder={"شماره موبایل خود را وارد کنید..."}
          onChange={handleChangePhoneNumber}
          helperText={
            <Box sx={{ display: "flex", alignItems: "end", ml: -1, mt: 1 }}>
              <InfoIcon fontSize="small" />

              <Typography
                variant="body2"
                ml={1}
                sx={{ fontFamily: "IRANSansX", fontSize: "12px" }}
              >
                شماره موبایل شما باید با کد ملی شما مطابقت داشته باشد.
              </Typography>
            </Box>
          }
          helperStyle={{
            color: "#BA8314",
            fontFamily: "IRANSansX",
          }}
          {...customInputProps(theme)}
        />

        <CustomButton
          value={"ثبت"}
          onClickHandler={handleLogin}
          buttonType={ButtonType.actionButton}
          customButtonStyle={{
            backgroundColor: "#00695f",
            borderRadius: "12px",
            width: "97%",
            marginTop: 4,
          }}
          textStyle={{
            fontFamily: "IRANSansX",
          }}
        />
      </Box>
    </Box>
  );
};

export default ForgotPassword;
